import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css"
import "../Components/HeadSection/headSection.css";
import Button from "../Components/Buttons/Button";
import llmStudio from "../Assets/Images/Illustrations/llmstudio.svg"
import llmStudio_small from "../Assets/Images/Illustrations/llmstudio_small.svg"
import MetaData from "../Components/MetaData/MetaData";
import {DefaultParameters} from "../api/ApiCallMethod";
import Illustration from "../Assets/Images/Illustrations/Illustration";
import NavigatingGPTCrossRoad from "../Components/Diagrams/NavigatingGPTCrossRoad";
import RedCircle from "../Assets/Images/Illustrations/RedEllipse.svg"

import UIGen from "../Assets/Images/StudioBlocks/studio_UIGen.svg"
import APIGen from "../Assets/Images/StudioBlocks/studio_APIGen.svg"
import DBGen from "../Assets/Images/StudioBlocks/studio_DBGen.svg"

import FeatureStudio from "../Assets/Images/StudioBlocks/studio_FeatureStudio.svg"
import KubernetesManager from "../Assets/Images/StudioBlocks/studio_KubernetesManager.svg"
import CLoudManager from "../Assets/Images/StudioBlocks/studio_CloudManager.svg"

import Bloom from "../Assets/Images/StudioBlocks/studio_Bloom.svg"
import Falcon from "../Assets/Images/StudioBlocks/studio_Falcon.svg"
import MyLLM from "../Assets/Images/StudioBlocks/studio_MyLLM.svg"

import Line from "../Assets/Images/StudioBlocks/studio_Line.svg"
import landingImage from "../Assets/Images/Illustrations/landing_image.svg";
import landingImageMobile from "../Assets/Images/Illustrations/landing_image_mobile.svg";
import landingImageTablet from "../Assets/Images/Illustrations/landing_image_tablet.svg";



import DesktopHomeBackground from "../Assets/Images/HeadBackgrounds/home_desktop.svg"
import TableHomeBackground from "../Assets/Images/HeadBackgrounds/home_tablet.svg"
import MiniTabletBackground from "../Assets/Images/HeadBackgrounds/home_mini_tablet.svg"
import MidTabletBackground from "../Assets/Images/HeadBackgrounds/home_mid_tablet.svg"
import LargePhoneBackground from "../Assets/Images/HeadBackgrounds/home_large_phone.svg"
import MidPhoneBackground from "../Assets/Images/HeadBackgrounds/home_mid_phone.svg"
import MiniPhoneBackground from "../Assets/Images/HeadBackgrounds/home_mini_phone.svg"
import PadBackground from "../Assets/Images/HeadBackgrounds/home_pad.svg"
import MidPadBackground from "../Assets/Images/HeadBackgrounds/home_mid_pad.svg"
import MiniPadBackground from "../Assets/Images/HeadBackgrounds/home_mini_pad.svg"
import SmallestBackground from "../Assets/Images/HeadBackgrounds/home_smallest.svg"


export const StudioLLMNodes = [
    {Block: UIGen},
    {Block: APIGen},
    {Block: DBGen},
]

export const StudioPlatform = [
    {Block: FeatureStudio},
    {Block: CLoudManager},
    {Block: KubernetesManager},
]
export const StudioOne = [
    {Block: Bloom},
    {Block: Falcon},
    {Block: MyLLM},
]

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.LLMStudioDiagramRef = React.createRef();
        this.state = {
            mottoTagList: [
                "Any LLM", "Any Language", "Any Cloud",
            ],
            propertyList: [
                "Secure", "Private", "Confident"
            ],
            launchingSoonPopup: false,
            updateParticleComponent: false,
            imageIsReady: false,
        }
    }


    login = () => {
        let productUrl = DefaultParameters().ProductURL
        productUrl += DefaultParameters().SignupRoute
        window.open(productUrl, '_blank');

    }
    openMainVideo = () => {
        let {openProductVideo} = this.props;
        openProductVideo();
    }

    showLLMStudio = () =>{
        this.LLMStudioDiagramRef.current.scrollIntoView({
            behavior: "smooth",

        })
    }

    render() {
        let {mottoTagList, propertyList} = this.state;
        return (
            <div className="home-layout">
                <MetaData keyword={"home"}/>
                <div className="head-section" style={{minHeight: "calc(var(--landingHeight))"}}>
                    <img src={DesktopHomeBackground} alt={""} className="head-section-background desktop"/>
                    <img src={TableHomeBackground} alt={""} className="head-section-background tablet"/>
                    <img src={MidTabletBackground} alt={""} className="head-section-background mid-tablet"/>
                    <img src={MiniTabletBackground} alt={""} className="head-section-background mini-tablet"/>
                    <img src={LargePhoneBackground} alt={""} className="head-section-background large-phone"/>
                    <img src={MidPhoneBackground} alt={""} className="head-section-background mid-phone"/>
                    <img src={MiniPhoneBackground} alt={""} className="head-section-background mini-phone"/>
                    <img src={PadBackground} alt={""} className="head-section-background pad"/>
                    <img src={MidPadBackground} alt={""} className="head-section-background mid-pad"/>
                    <img src={MiniPadBackground} alt={""} className="head-section-background mini-pad"/>
                    <img src={SmallestBackground} alt={""} className="head-section-background smallest"/>
                    <div className="landing-section">
                        <div className="landing-section--left" >
                            <div className="landing-section-left-upper">
                                <h1 className="default-header-style motto-main-text">Chatbot Any Data</h1>
                                <div className="motto-tag-row">
                                    {
                                        mottoTagList.map((res, index) =>
                                            <div className="motto-tag" key={index} onClick={this.showLLMStudio.bind(this)}>
                                                {res}
                                            </div>
                                        )
                                    }

                                </div>
                                <div className="landing-action-row">
                                    <Button type="secondary"
                                            width={"180px"}
                                            onClick={this.openMainVideo.bind(this)}>How it works</Button>
                                    <Button width={"180px"} onClick={this.login.bind(this)}>Get Started</Button>
                                </div>
                            </div>
                            <div className="landing-section-left-lower">
                                <h2 className="motto-main-text">
                                    {"Auto-generate \nLLM-powered AI Apps"}
                                </h2>
                                <div className="motto-tag-row unclickable">
                                    {
                                        propertyList.map((res, index) =>
                                            <div className="motto-tag" key={index}>
                                                {/*<div className="motto-tag-bullet"/>*/}
                                                {res}
                                            </div>
                                        )
                                    }

                                </div>
                            </div>

                        </div>
                        <div className="landing-section--right">
                            <img src={landingImage} alt={"Hero Image"} className="landing-section-image"/>
                            <img src={landingImageMobile} alt={"Hero Image"} className="landing-section-image mobile"/>
                            <img src={landingImageTablet} alt={"Hero Image"} className="landing-section-image tablet"/>
                        </div>
                    </div>
                </div>

                <div className="diagram-section">
                    <h1 className="diagram-section-header red">
                        Navigating GPT Crossroads
                    </h1>
                    <div className="diagram-section-description">
                        Enterprise Personas' Road Blocks  in the Complex World of GenAI
                    </div>
                    <div className="diagram-section-diagram-container">
                        <div className="diagram-section-diagram-box">
                            <div className="diagram-section-background-circle-container">
                                <span className="diagram-anygen-problem">GPT</span>
                                <img src={RedCircle} alt={""} className="diagram-section-background-circle"/>
                            </div>
                            <NavigatingGPTCrossRoad type={"problem"}/>
                        </div>


                    </div>

                </div>
                <div className="diagram-section">
                    <h1 className="diagram-section-header">
                        Anygen Solution
                    </h1>
                    <div className="diagram-section-description">
                        Omni Solution for Enterprise Gen AI
                    </div>
                    <div className="diagram-section-diagram-container">
                        <div className="diagram-section-diagram-box">
                            <div className="diagram-section-background-circle-container solution-diagram">
                                <span className="diagram-anygen-solution">AnyGen</span>
                                <img src={RedCircle} alt={""} className="diagram-section-background-circle"/>
                            </div>
                            <NavigatingGPTCrossRoad type={"solution"}/>
                        </div>
                    </div>
                </div>
                <div className="diagram-section llm-studio" ref={this.LLMStudioDiagramRef}>
                    <div className="studio-diagram-section">
                        <img src={llmStudio} className="studio-background-diagram" alt={"AnyGen LLM Studio"}/>
                        <img src={llmStudio_small} className="studio-background-diagram small" alt={"AnyGen LLM Studio"}/>
                        <div className="studio-diagram-block-layout">
                            <div className="studio-diagram-block-layout--left">
                                <div className="studio-diagram-block-container">
                                    <img src={UIGen} alt={""} className="studio-diagram-block"/>
                                    <img src={APIGen} alt={""} className="studio-diagram-block"/>
                                    <img src={DBGen} alt={""} className="studio-diagram-block"/>
                                </div>
                                <div className="studio-diagram-block-container">
                                    <img src={FeatureStudio} alt={""} className="studio-diagram-block"/>
                                    <img src={CLoudManager} alt={""} className="studio-diagram-block"/>
                                    <img src={KubernetesManager} alt={""} className="studio-diagram-block"/>

                                </div>
                            </div>
                            <div className="studio-diagram-block-layout--right">
                                <div className="studio-diagram-right-upper">
                                    <img src={Falcon} alt={""} className="studio-diagram-block"/>


                                </div>
                                <div className="studio-diagram-right-lower">
                                    <img src={Bloom} alt={""} className="studio-diagram-block"/>
                                    <img src={Line} alt={""} className="studio-diagram-block-line"/>
                                    <img src={MyLLM} alt={""} className="studio-diagram-block"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}